"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[126],{

/***/ 8870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6139);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7627);





var accordionAnim = {
    open: {
        opacity: 1,
        height: "auto"
    },
    closed: {
        opacity: 0,
        height: 0
    }
};
var Accordion = function(param) {
    var id = param.id, title = param.title, _tooltip = param.tooltip, tooltip = _tooltip === void 0 ? false : _tooltip, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, _style = param.style, style = _style === void 0 ? "default" : _style, _isControlled = param.isControlled, isControlled = _isControlled === void 0 ? false : _isControlled, _onToggle = param.onToggle, onToggle = _onToggle === void 0 ? function() {} : _onToggle, className = param.className, children = param.children, _value = param.value, value = _value === void 0 ? false : _value;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen), hasFocus = ref[0], setHasFocus = ref[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion", className),
        children: [
            !isControlled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                onClick: function() {
                    return onToggle(id, !isOpen);
                },
                "aria-expanded": isOpen,
                "aria-controls": "accordion-".concat(id),
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--toggle type--h-sm flex w-full text-left items-center", "p-5", "mb-2", "rounded-[3px]", {
                    "border-t px-0 uppercase mb-0 rounded-t-none": style == "mobile-alt",
                    "bg-white": style == "default",
                    "is-open": isOpen,
                    "bg-yellow": isOpen && style !== "mobile-alt"
                }),
                children: [
                    title,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--icon", "inline-flex", "items-center", "transition-transform", "md:ml-auto", "relative", "top-[-2px]", "w-[20px]", "h-[20px]", "md:w-[28px]", "md:h-[28px]", {
                            "rotate-45": isOpen,
                            "ml-auto": !value
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            name: "AccordionIcon",
                            id: "-".concat(id),
                            viewBox: "0 0 28 28",
                            color: "#000000",
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-[28px]")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                id: "accordion-".concat(id),
                className: "accordion--content",
                initial: isOpen ? "open" : "closed",
                animate: isOpen ? "open" : "closed",
                variants: accordionAnim,
                transition: {
                    duration: 0.5,
                    ease: [
                        0.19,
                        1,
                        0.22,
                        1
                    ]
                },
                onAnimationComplete: function(v) {
                    return setHasFocus(v === "open");
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("accordion--inner", "type--base", "pt-1", "pb-5", "md:pb-3"),
                    hidden: !isOpen && !hasFocus,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: children
                    })
                })
            })
        ]
    }, id));
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ block_content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(8863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/link.js + 1 modules
var components_link = __webpack_require__(8250);
;// CONCATENATED MODULE: ./components/block-serializers.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var blockSerializers = {
    types: {
        block: function(props) {
            var _node = props.node, markDefs = _node.markDefs, _style = _node.style, style = _style === void 0 ? "normal" : _style;
            // check if our block contains a button
            var hasButton = markDefs && markDefs.some(function(c) {
                return c._type === "link" && c.isButton === true;
            });
            // build our mock header styles
            if (style === "h1mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h1", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h2mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h2", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h3mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h4mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h4", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h5mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h5", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h6mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h6", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "large") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-lg-3-mobile", "md:text-lg-3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-large", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadSmall") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-small", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-large font-sansRegular", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "caption") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-caption", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            // go through our remaing, true header styles
            if (/^h\d/.test(style)) {
                return(/*#__PURE__*/ react.createElement(style, {
                    className: hasButton ? "has-btn" : null
                }, props.children));
            }
            // handle all other blocks with the default serializer
            return BlockContent_default().defaultSerializers.types.block(props);
        },
        photo: function(param) {
            var node = param.node;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                photo: node
            }));
        },
        horizontalRule: function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("hr", {});
        }
    },
    marks: {
        link: function(param) {
            var mark = param.mark, children = param.children;
            var title = children[0];
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                link: _objectSpread({}, mark, {
                    title: title
                })
            }));
        }
    }
};

;// CONCATENATED MODULE: ./components/block-content.js





var Content = function(param) {
    var blocks = param.blocks, className = param.className;
    if (!blocks) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        renderContainerOnSingleChild: true,
        className: classnames_default()("rc", className),
        blocks: blocks,
        serializers: blockSerializers
    }));
};
/* harmony default export */ var block_content = (Content);


/***/ }),

/***/ 5126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);
/* harmony import */ var _components_phrase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1995);
/* harmony import */ var _components_accordion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8870);
/* harmony import */ var _components_block_content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1255);







function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Expanders = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var phrase = data.phrase, image = data.image, introText = data.introText, expanders = data.expanders;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), activeAccordions = ref[0], setActiveAccordions = ref[1];
    var addOrRemove = function(arr, item) {
        return arr.includes(item) ? arr.filter(function(i) {
            return i !== item;
        }) : _toConsumableArray(arr).concat([
            item
        ]);
    };
    var onToggle = function(id, status) {
        setActiveAccordions(addOrRemove(activeAccordions, id));
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("expanders", "p-4", "md:p-10", "py-20", "relative", "z-0", "bg-gray"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-1", "md:grid-cols-20", "site-container"),
            children: [
                phrase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-1", "md:col-span-12", "md:col-start-5", "text-center", "py-5"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-10", "mb-[-78px]", "mx-auto", "w-full", "max-w-[70%]", "md:max-w-[500px]"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                photo: image,
                                width: 1200,
                                layout: "intrinsic"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-10", "mb-3", "mx-auto", "relative", "z-10"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_phrase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                phrase: phrase,
                                typeStyle: "text-lg-1-mobile md:text-lg-1",
                                dividerMaxWidth: "50vw",
                                reverse: true
                            })
                        })
                    ]
                }),
                introText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-1", "md:col-span-10", "md:col-start-6", "text-center", "py-5", "mb-10", "text-large", "font-sansRegular"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        blocks: introText
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-1", "md:col-span-14", "md:col-start-4"),
                    children: expanders.map(function(expander, idx1) {
                        var title = "";
                        if (expander.sublabel && !expander.label) {
                            title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-subheader-2 leading-[1.3] uppercase font-sansRegular",
                                children: expander.sublabel
                            });
                        }
                        if (expander.label) {
                            title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-subheader-2 leading-[1.3] uppercase font-sansRegular",
                                children: expander.label
                            });
                            if (expander.sublabel) {
                                title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-caption uppercase font-sansRegular tracking-[0.18em]",
                                            children: expander.sublabel
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-lg-3",
                                            children: expander.label
                                        })
                                    ]
                                });
                            }
                        }
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_accordion__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            title: title,
                            id: "expanders-dropdown-".concat(idx1),
                            isOpen: activeAccordions.indexOf("expanders-dropdown-".concat(idx1)) > -1 ? true : false,
                            onToggle: onToggle,
                            children: [
                                expander.body && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text", "p-4", "text-large", "font-sansRegular", "tracking-[0.0em]", "md:max-w-[80%]"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        blocks: expander.body
                                    })
                                }),
                                expander.specs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text", "sm:w-1/2", "sm:ml-auto", "pl-5", "sm:pl-0", "pr-4", "my-2"),
                                    children: expander.specs.map(function(spec, idx) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mb-5"),
                                            children: [
                                                spec.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-subheader", "font-sansSemiBold", "mb-1"),
                                                    children: spec.title
                                                }),
                                                spec.text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-large", "font-sansRegular", "mb-1"),
                                                    dangerouslySetInnerHTML: {
                                                        __html: spec.text.replace(/\n/g, "<br />")
                                                    }
                                                }),
                                                spec.part && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-caption", "font-sansRegular", "uppercase", "opacity-50"),
                                                    children: spec.part
                                                })
                                            ]
                                        }, idx);
                                    })
                                })
                            ]
                        }, idx1));
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Expanders);


/***/ })

}]);